var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 12.705H8.229v-.32H145v.32zM145 24.293H8.229v-.321H145v.321zM145 35.874H8.229v-.32H145v.32zM145 47.462H8.229v-.321H145v.32zM145 59.043H8.229v-.321H145v.321zM145 70.63H8.229v-.32H145v.32zM145 82.218H8.229v-.32H145v.32z",
    fill: "#EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.197 7.066h-6.424v75.153h6.424V7.066z",
    fill: "#4179A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.547 61.664h-6.423v20.555h6.423V61.664z",
    fill: "#52B2CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.175 42.394h-6.423v39.825h6.423V42.394z",
    fill: "#4179A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.525 50.102h-6.423v32.117h6.423V50.102z",
    fill: "#52B2CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.795 12.847h-5.781v69.371h5.78V12.847z",
    fill: "#4179A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.145 39.825h-6.423v42.393h6.423V39.825z",
    fill: "#52B2CA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.773 64.876h-5.78v17.342h5.78V64.875z",
    fill: "#4179A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.124 77.722H104.7v4.497h6.424v-4.497z",
    fill: "#52B2CA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M130.393 8.35h-6.423v73.868h6.423V8.35z",
    fill: "#4179A8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M138.744 52.671h-6.424V82.22h6.424V52.67z",
    fill: "#52B2CA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.265 86.015H17.24v1.965h9.025v-1.965zM5.26 81.069H0v1.965h5.26V81.07zM5.26 69.487H0v1.966h5.26v-1.966zM5.26 57.9H0v1.965h5.26V57.9zM5.26 46.319H0v1.965h5.26V46.32zM5.26 34.73H0v1.966h5.26v-1.965zM5.26 11.562H0v1.966h5.26v-1.966zM5.26 23.15H0v1.965h5.26V23.15zM52.729 86.015h-9.025v1.965h9.025v-1.965zM81.126 86.015h-9.024v1.965h9.024v-1.965zM108.811 86.015h-9.025v1.965h9.025v-1.965zM136.136 86.015h-9.025v1.965h9.025v-1.965z",
    fill: "#EEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 1.143H8.229v-.32H145v.32z",
    fill: "#EEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26 0H0v1.966h5.26V0z",
    fill: "#EEE"
  })));
}
export default SvgColumn;